/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { GroupUser } from './GroupUser';
import { NormalUser } from './NormalUser';
const UserParser = /* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['normal', NormalUser],
    ['group-user', GroupUser],
]);
export const User = UserParser;
